module.exports = __webpack_public_path__ + "static/img/one.191231e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/strawberryImg/one.png
// module id = bN+O
// module chunks = 1